const APPLICATION_EVENTS = {
    MARK_FORM_AS_SUBMITTED: 'MARK_FORM_AS_SUBMITTED'
};

export default APPLICATION_EVENTS;


// WEBPACK FOOTER //
// ./src/app/constants/applicationEvents.constant.js